import styled, { css } from 'styled-components';

import { breakpoints } from '@shared/constants';

export const ChatWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-end;
    min-height: 300px;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        height: auto;
    }
`;

export const ProgressBarWrapper = styled.div(
    ({ theme: { palette } }) => css`
        background-color: ${palette.neutral.white};
        width: 100%;

        @media (max-width: ${breakpoints.md}px) {
            padding: 16px 0;
        }
    `,
);
